import React from "react";
import "./App.css";
// import Header from "./components/Header";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles"; 
import { grey } from "@material-ui/core/colors";
import SearchLine from "./components/SearchLine";
import Profile from "./components/profile";
import Navigation from "./components/Navigation";
import Loader from "./components/Loader";
import { useAuth0 } from "@auth0/auth0-react";
import ProtectedRoute from './components/protected-route';
import LinesWithDataUsage from "./components/LinesWithDataUsage";
import AssignLines from "./components/AssignLines";
const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#1D4354",
    },
    secondary: {
      main: "#6FDA44",
    },
  },
  typography: {
    fontFamily: [
      "Montserrat",
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
  },
  colors: {
    green: "#6FDA44",
    darkBlue: "#1D4354",
    grey: "#f2f2f2",
  },
});

function App() {
  const { isLoading } = useAuth0();
  if (isLoading) {
    return <Loader />;
  } else {
    return (
      <ThemeProvider theme={theme}>
        <div className="App">
          <Navigation />

          <div className="mainPanel" style={{ backgroundColor: grey[50] }}>
          <ProtectedRoute path="/" exact={true} component={SearchLine} />
            <ProtectedRoute path="/search-line" component={SearchLine} />
            <ProtectedRoute path="/profile" component={Profile} />
            <ProtectedRoute path="/lines-data-usage" component={LinesWithDataUsage} />
            <ProtectedRoute path="/assign-lines" component={AssignLines} />
          </div>
        </div>
      </ThemeProvider>
    );
  }
}

export default App;
